import { TableFilters } from "./TableBase";
import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';

/**
 * Definitions for the Encoded and Decoded Query Filter Objects, these 
 * objects are used to allow for storing more information in the future 
 * such as columns to display and supporting other types of encoding 
 * such as server side in Redis with just an identifier in the query string
 */
export type EncodedQueryFilter = {
    filterType: string,
    filterValue: string
}

export type DecodedQueryFilter = {
    filters: TableFilters
}

export class TableFilterQueryHelper {
    /**
     * Compresses and encodes a set of table filters and returns 
     * them in an encoded query filter object
     * @param decodedQueryFilter - The Decoded Query Filter to encode
     * @returns An EncodedQueryFilter containing the filter type and filter value
     */
    static encode(decodedQueryFilter: DecodedQueryFilter) : EncodedQueryFilter {
        const decodedFilterValue = JSON.stringify(decodedQueryFilter);
        const filterValue = compressToEncodedURIComponent(decodedFilterValue);

        return {
            filterType: "c",
            filterValue: filterValue
        }
    }

    /**
     * Compresses and encodes a set of table filters and returns them 
     * as a query string that can be appended to a navigate route or URL
     * @param decodedQueryFilter 
     * @returns A string containing the filter type and filter value as query 
     * string values in URI encoded format
     */
    static encodeToQueryString(decodedQueryFilter: DecodedQueryFilter) : string {

        const encoded = TableFilterQueryHelper.encode(decodedQueryFilter);
    
        return `ft=${encoded.filterType}&fv=${encoded.filterValue}`;
    }

    /**
     * Decodes an encoded Query Filter and returns a decoded object containing 
     * the query filters
     * @param encodedQueryFilter  - Encoded Query filter object to be decoded
     * @returns Decoded query filter object containing the table filters
     */
    static decode(encodedQueryFilter: EncodedQueryFilter) : DecodedQueryFilter | null {
        try {
            if (encodedQueryFilter.filterType === "c") {
                if (encodedQueryFilter.filterValue !== null) {
                    return JSON.parse(decompressFromEncodedURIComponent(encodedQueryFilter.filterValue));
                }
            }

            return null;
        } catch {
            console.warn("Failed to decode query string filter");
            return null;
        }
    }
}